<template>
  <div>
    <div v-if="!notEmptyObject(pre_agreement) && !$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
      <create_pre_agreement :company="company" :d_payment_process_info="payment_process_info" :d_referral_rebate="referral_rebate"></create_pre_agreement>
    </div>
    <div v-else-if="edit_pre_agreement && !$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
      <edit_pre_agreement :company="company" :d_payment_process_info="payment_process_info" :d_referral_rebate="referral_rebate"
                          :d_pre_agreement="pre_agreement"></edit_pre_agreement>
    </div>
    <div v-else class="row">
      <div class="col-12 mt-3">
        <b-card header="Company Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row">
            <!-- LTD Company Registration Number -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="ltd_company_reg_number">LTD Registration Number</label>
              <p id="ltd_company_reg_number">
                <span v-if="company.rel_profile.ltd_reg_number !== null">{{ company.rel_profile.ltd_reg_number }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- LTD Incorporation Date -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="incorporation_date">LTD Incorporation Date</label>
              <p id="incorporation_date">
                <span v-if="company.rel_profile.ltd_incorporation_date !== null">{{ company.rel_profile.ltd_incorporation_date | formatDate }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- Company UTR Number -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="company_utr_number">Company UTR Number</label>
              <p id="company_utr_number">
                <span v-if="company.rel_profile.utr_number !== null">{{ company.rel_profile.utr_number }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- UTR Status -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="company_utr_status">UTR Status</label>
              <p id="company_utr_status">
                <span v-if="company.rel_profile.utr_status !== null">{{ company.rel_profile.utr_status }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
          </div>
          <div class="row">
            <!-- UK VAT Registered -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="uk_vat_registered">UK VAT Registered</label>
              <p id="uk_vat_registered">
                <span v-if="company.rel_profile.vat_registered">Yes</span>
                <span v-else-if="!company.rel_profile.vat_registered">No</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- VAT Registration Number -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="vat_registration_number">VAT Registration Number</label>
              <p id="vat_registration_number">
                <span v-if="company.rel_profile.vat_number !== null">{{ company.rel_profile.vat_number }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
          </div>
          <div class="row">
            <!-- Fall within Off-Payroll / Qualify for Accounts Audit -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="off_payroll_accounts_audit">Fall within Off-Payroll / Qualify for Accounts Audit</label>
              <p id="off_payroll_accounts_audit">
                <span v-if="company.rel_profile.inside_off_payroll">Yes</span>
                <span v-else-if="!company.rel_profile.inside_off_payroll">No</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- Main Operating Sector -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="operating_sector">Main Operating Sector</label>
              <p id="operating_sector">
                <span v-if="company.rel_profile.main_operating_sector !== null">{{ company.rel_profile.main_operating_sector }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- Domestic/Commercial Operations -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="main_area_operation">Domestic/Commercial Operations</label>
              <p id="main_area_operation">
                <span v-if="company.rel_profile.domestic_commercial !== null">{{ company.rel_profile.domestic_commercial }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <hr>
            </div>
          </div>
          <div class="row">
            <!-- Signed up to CITB -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="signed_up_to_citb">Signed up to CITB</label>
              <p id="signed_up_to_citb">
                <span v-if="company.rel_profile.signed_up_to_citb">Yes</span>
                <span v-else-if="!company.rel_profile.signed_up_to_citb">No</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- Pass CITB charge on to Contractors -->
            <div class="col-xl-6 form-group" v-if="company.rel_profile.signed_up_to_citb">
              <label class="form-label" for="pass_citb_charge_on_to_contractor">Pass CITB charge on to Contractors</label>
              <p id="pass_citb_charge_on_to_contractor">
                <span v-if="company.rel_profile.pass_citb_charge_to_contractors">Yes</span>
                <span v-else-if="!company.rel_profile.pass_citb_charge_to_contractors">No</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <hr>
            </div>
            <div class="col-12">
              <h5 class="font-weight-bold">Accountant</h5>
            </div>
            <!-- Currently use an Accountant -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="currently_use_accountant">Currently use an Accountant</label>
              <p id="currently_use_accountant">
                <span v-if="company.rel_profile.use_accountant">Yes</span>
                <span v-else-if="!company.rel_profile.use_accountant">No</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <div class="col-12" v-if="company.rel_profile.use_accountant">
              <div class="row">
                <!-- Accountant Company Name -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="accountant_company_name">Accountant Company Name</label>
                  <p id="accountant_company_name">
                    <span v-if="company.rel_profile.accountant_company_name !== null">{{ company.rel_profile.accountant_company_name }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Accountant Contact Number -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="accountant_contact_number">Accountant Contact Number</label>
                  <p id="accountant_contact_number">
                    <span v-if="company.rel_profile.accountant_contact_number !== null">{{ company.rel_profile.accountant_contact_number }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Contractor HR advice from Accountants -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="contractor_hr_advice_from_accountants">Contractor HR advice from Accountants</label>
                  <p id="contractor_hr_advice_from_accountants">
                    <span v-if="company.rel_profile.accountant_hr_advice">Yes</span>
                    <span v-else-if="!company.rel_profile.accountant_hr_advice">No</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-12">
              <hr>
            </div>

            <div class="col-12">
              <h5 class="font-weight-bold">Employment Law/HR</h5>
            </div>
            <!-- Outsource Employment Law/HR -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="outsource_employment_law_hr">Outsource Employment Law/HR</label>
              <p id="outsource_employment_law_hr">
                <span v-if="company.rel_profile.employment_law_hr">Yes</span>
                <span v-else-if="!company.rel_profile.employment_law_hr">No</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <div class="col-12" v-if="company.rel_profile.employment_law_hr">
              <div class="row">
                <!-- Outsourced Employment Law/HR Yearly Spend -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="outsourced_employment_law_hr_yearly_spend">Yearly Spend</label>
                  <p id="outsourced_employment_law_hr_yearly_spend">
                    <span v-if="company.rel_profile.employment_law_hr_yearly_spend !== null">{{ company.rel_profile.employment_law_hr_yearly_spend }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Employment Law/HR Company Name -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="outsourced_employment_law_hr_company_name">Company Name</label>
                  <p id="outsourced_employment_law_hr_company_name">
                    <span v-if="company.rel_profile.employment_law_hr_company_name !== null">{{ company.rel_profile.employment_law_hr_company_name }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Employment Law/HR Contact Number -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="outsourced_employment_law_hr_contact_number">Contact Number</label>
                  <p id="outsourced_employment_law_hr_contact_number">
                    <span v-if="company.rel_profile.employment_law_hr_contact_number !== null">{{ company.rel_profile.employment_law_hr_contact_number }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <!-- Current IR35 Strategy -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="current_ir35_strategy">Current IR35 Strategy</label>
                  <p id="current_ir35_strategy">
                    <span v-if="company.rel_profile.employment_law_hr_ir35_strategy !== null">{{ company.rel_profile.employment_law_hr_ir35_strategy }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Current Off-Payroll Strategy -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="current_off_payroll_strategy">Current Off-Payroll Strategy</label>
                  <p id="current_off_payroll_strategy">
                    <span v-if="company.rel_profile.employment_law_hr_off_payroll_strategy !== null">{{ company.rel_profile.employment_law_hr_off_payroll_strategy }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-12">
        <b-card header="Current Staff/Contractor Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row">
            <div class="col-12">
              <h5 class="font-weight-bold">Staff/Contractor Engagement</h5>
            </div>
            <!-- Number of Limited Companies -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="number_of_ltd_companies_engaged">Number of Limited Companies</label>
              <p id="number_of_ltd_companies_engaged">
                <span v-if="company.rel_profile.num_ltd_companies_engaged !== null">{{ company.rel_profile.num_ltd_companies_engaged }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- Number of PSC's -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="number_of_pscs_engaged"> Number of PSC's</label>
              <p id="number_of_pscs_engaged">
                <span v-if="company.rel_profile.num_pscs_engaged !== null">{{ company.rel_profile.num_pscs_engaged }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- Number of Labour only Sub-Contractors (CIS) -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="number_of_sub_contractors_engaged">Number of Labour only Sub-Contractors (CIS)</label>
              <p id="number_of_sub_contractors_engaged">
                <span v-if="company.rel_profile.num_cis_sub_contractors_engaged !== null">{{ company.rel_profile.num_cis_sub_contractors_engaged }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- Number of PAYE -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="number_of_paye_engaged">Number of PAYE</label>
              <p id="number_of_paye_engaged">
                <span v-if="company.rel_profile.num_paye_engaged !== null">{{ company.rel_profile.num_paye_engaged }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>

            <div class="col-12">
              <hr>
            </div>
            <div class="col-12">
              <h5 class="font-weight-bold">Recruitment</h5>
            </div>
            <!-- Currently use Recruitment Agencies -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="use_recruitment_agencies">Currently use Recruitment Agencies</label>
              <p id="use_recruitment_agencies">
                <span v-if="company.rel_profile.use_recruitment_agencies">Yes</span>
                <span v-else-if="!company.rel_profile.use_recruitment_agencies">No</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <div class="col-12" v-if="company.rel_profile.use_recruitment_agencies">
              <div class="row">
                <!-- Approx weekly numbers -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="recruitment_approx_weekly_numbers">Approx weekly numbers</label>
                  <p id="recruitment_approx_weekly_numbers">
                    <span v-if="company.rel_profile.recruitment_agencies_weekly_num !== null">{{ company.rel_profile.recruitment_agencies_weekly_num }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Recruitment Payroll Companies -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="recruitment_payroll_companies">Recruitment Agency Payroll Companies & how Operate</label>
                  <p id="recruitment_payroll_companies">
                    <span v-if="company.rel_profile.recruitment_agencies_payroll_how_operate !== null">{{ company.rel_profile.recruitment_agencies_payroll_how_operate }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-12">
        <b-card header="Payment Information/Process" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row">
            <!-- Pay Frequency -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="pay_frequency">Pay Frequency</label>
              <p v-if="payment_process_info.pay_cycle_id !== null" id="pay_frequency">
                {{ $store.state.crm_options.pay_cycle.find(p => p.id === payment_process_info.pay_cycle_id).value }}
              </p>
              <p v-else>&nbsp;</p>
            </div>
            <!-- Timesheet Frequency -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="timesheet_frequency">Timesheet Frequency</label>
              <p v-if="payment_process_info.timesheet_cycle_id !== null" id="timesheet_frequency">
                {{ $store.state.crm_options.timesheet_cycle.find(p => p.id === payment_process_info.timesheet_cycle_id).value }}
              </p>
              <p v-else>&nbsp;</p>
            </div>
            <!-- Working week start day -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="working_week_start_day">Working week start day</label>
              <p id="working_week_start_day">{{ payment_process_info.pay_week_start_day }}</p>
            </div>
            <div class="col-12">
              <hr class="mt-0 mb-3">
            </div>
            <!-- Client Instruction Day -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="client_instruction_day">Client Instruction Day</label>
              <p id="client_instruction_day">{{ payment_process_info.pay_instruction_day }}</p>
            </div>
            <!-- Client Payment to Genius Day -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="client_payment_to_gm_day">Client Payment to Genius Day</label>
              <p id="client_payment_to_gm_day">{{ payment_process_info.pay_client_payment_day }}</p>
            </div>
            <!-- Genius Payment to Worker Day -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="gm_payment_worker_day">Genius Payment to Worker Day</label>
              <p id="gm_payment_worker_day">{{ payment_process_info.pay_worker_payment_day }}</p>
            </div>
            <!-- Genius Payment to Worker Time -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="gm_payment_worker_time">Genius Payment to Worker Time</label>
              <p id="gm_payment_worker_time">{{ payment_process_info.pay_worker_payment_time }}</p>
            </div>
            <!-- Genius Text to Worker Day -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="pay_worker_text_day">Genius Text to Worker Day</label>
              <p id="pay_worker_text_day">{{ payment_process_info.pay_worker_text_day }}</p>
            </div>
            <div class="col-12">
              <hr class="mt-0 mb-3">
            </div>
            <!-- Genius Charge Agreed -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="genius_charge_agreed">Fee/Margin Agreed</label>
              <p id="genius_charge_agreed">
                <span v-if="payment_process_info.fee_margin_agreed">Yes</span>
                <span v-if="!payment_process_info.fee_margin_agreed">No</span>
              </p>
            </div>
            <div class="col-xl-6"></div>
            <div class="col-xl-6 form-group">
              <label class="form-label" for="payroll_pe_insurance">P.E. Insurance Included</label>
              <p id="payroll_pe_insurance">
                <span v-if="payment_process_info.payroll_pe_insurance">Yes - A Charge of {{ pe_ins | currency }} will be made on top of the agreed Admin Charge</span>
                <span v-if="!payment_process_info.payroll_pe_insurance">No</span>
              </p>
            </div>
            <div class="col-xl-6 form-group">
              <label class="form-label" for="payroll_pa_insurance">Worker P.A. Insurance Included</label>
              <p id="payroll_pa_insurance">
                <span v-if="payment_process_info.payroll_pa_insurance">Yes - A Charge of {{ pa_ins | currency }} will be made on top of the agreed Admin Charge</span>
                <span v-if="!payment_process_info.payroll_pa_insurance">No</span>
              </p>
            </div>

            <!-- Genius Charge type -->
            <div v-if="payment_process_info.fee_margin_agreed" class="col-xl-6 form-group">
              <label class="form-label" for="genius_charge_type">Fee/Margin type</label>
              <p id="genius_charge_type">{{ payment_process_info.fee_margin_type }}</p>
            </div>
            <!-- Genius Charge value -->
            <div v-if="payment_process_info.fee_margin_agreed" class="col-xl-6 form-group">
              <label class="form-label" for="genius_charge_value">Fee/Margin value</label>
              <p id="genius_charge_value">
                <span v-if="payment_process_info.fee_margin_type === '£ (Pound)'">{{ payment_process_info.fee_margin_amount | currency }}</span>
                <span v-if="payment_process_info.fee_margin_type === '% (Percentage)'">{{ payment_process_info.fee_margin_amount | percentage }}</span>
              </p>
            </div>
            <div v-else class="col-xl-6"></div>
            <!-- Require Payment Terms -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="require_payment_terms">Require Payment Terms</label>
              <p id="require_payment_terms">
                <span v-if="payment_process_info.payroll_require_payment_terms">Yes</span>
                <span v-if="!payment_process_info.payroll_require_payment_terms">No</span>
              </p>
            </div>
            <div class="col-xl-6"></div>
            <!-- Payment - Days from Invoice -->
            <div v-if="payment_process_info.payroll_require_payment_terms" class="col-xl-6 form-group">
              <label class="form-label" for="payment_days_from_invoice">Payment Terms - Days from Invoice</label>
              <p v-if="payment_process_info.payroll_payment_terms_length !== null" id="payment_days_from_invoice">{{ payment_process_info.payroll_payment_terms_length }} Day(s)</p>
            </div>
            <!-- Payment - Payment Terms Percentage Fee -->
            <div v-if="payment_process_info.payroll_require_payment_terms" class="col-xl-6 form-group">
              <label class="form-label" for="payment_terms_perc">Payment Terms Percentage Fee</label>
              <p v-if="payment_process_info.payroll_payment_terms_value !== null" id="payment_terms_perc">{{ payment_process_info.payroll_payment_terms_value | percentage }}</p>
              <p v-else></p>
            </div>
            <div v-else class="col-xl-6"></div>

            <div class="col-12">
              <hr class="mt-0 mb-3">
            </div>
            <!-- Genius Payroll Solution -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="gm_solution">Payroll Solution</label>
              <p id="gm_solution" v-if="payment_process_info.payroll_solution_id !== null">{{
                  this.$store.state.crm_options.payroll_client_solution.find(p => p.id ===
                      payment_process_info.payroll_solution_id).value
                }}</p>
            </div>
            <!-- VAT percentage worked to -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="vat_perc_worked_to">VAT percentage worked to</label>
              <p id="vat_perc_worked_to">{{ payment_process_info.min_vat_percentage_worked_to }}</p>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-12" v-if="!notEmptyObject(pre_agreement) && !$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
        <b-card header="V3 Recruitment Partnership" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row">
            <!-- Opt into V3 Partnership -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="v3_partnership">Opt into V3 Partnership</label>
              <p id="v3_partnership">
                <span v-if="payment_process_info.recruitment_partnership">Yes</span>
                <span v-if="!payment_process_info.recruitment_partnership">No</span>
              </p>
            </div>
            <!-- V3 Partnership margin type -->
            <div v-if="payment_process_info.recruitment_partnership" class="col-xl-6 form-group">
              <label class="form-label" for="v3_partnership_margin_type">Recruitment Partnership Margin Type</label>
              <p id="v3_partnership_margin_type">{{ payment_process_info.recruitment_partnership_fee_type }}</p>
            </div>
            <!-- V3 Partnership margin value -->
            <div v-if="payment_process_info.recruitment_partnership" class="col-xl-6 form-group">
              <label class="form-label" for="v3_partnership_margin_value">V3 Partnership Margin Value</label>
              <p id="v3_partnership_margin_value">
                <span v-if="payment_process_info.recruitment_partnership_fee_type === '£ (Pound)'">{{ payment_process_info.recruitment_partnership_fee_value | currency }}</span>
                <span
                    v-if="payment_process_info.recruitment_partnership_fee_type === '% (Percentage)'">{{
                    payment_process_info.recruitment_partnership_fee_value | percentage
                  }}</span>
              </p>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-12" v-if="!notEmptyObject(pre_agreement) && !$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
        <b-card header="Client Rebate" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row" v-if="notEmptyObject(referral_rebate) && notEmptyObject(referral_rebate.rebate)">
            <!-- Rebate Amount per payrolled worker -->
            <div class="col-xl-4 form-group">
              <label class="form-label" for="amount_per_payrolled_worker">Rebate Amount per payrolled worker</label>
              <p id="amount_per_payrolled_worker">
                <span>{{ referral_rebate.rebate.amount_per_payrolled_worker | currency }}</span>
              </p>
            </div>
            <!-- Referral start date -->
            <div class="col-xl-4 form-group">
              <label class="form-label" for="referral_start_date">Rebate start date</label>
              <p id="referral_start_date">
                <span>{{ referral_rebate.rebate.referral_start_date | formatDate }}</span>
              </p>
            </div>
            <!-- Referral end date -->
            <div class="col-xl-4 form-group">
              <label class="form-label" for="referral_end_date">Rebate end date</label>
              <p id="referral_end_date">
                <span>{{ referral_rebate.rebate.referral_end_date | formatDate }}</span>
              </p>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12">
              <p class="pt-0 mb-2">There is no rebate for this company</p>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import create_pre_agreement from "pages/companies/record/pre_agreement/create_pre_agreement";
import edit_pre_agreement from "pages/companies/record/pre_agreement/edit_pre_agreement";

export default {
  name: "pre_agreement",
  props: ['company', 'pre_agreement', 'credit_finance', 'payment_process_info', 'referral_rebate'],
  components: {
    create_pre_agreement,
    edit_pre_agreement
  },
  data() {
    return {
      pe_ins: process.env.MIX_PE_INS,
      pa_ins: process.env.MIX_PA_INS,
      edit_pre_agreement: false,
    }
  },
  methods: {
    edit_pre_agreement_btn() {
      this.edit_pre_agreement = true;
    }
  },
  watch: {
    edit_pre_agreement(val) {
      if (!val) {
        axios.get(this.crmApiPath + 'company/pre_agreement/company/' + this.$store.state.companies.current_record_company_id).then(pre_agreement => {
          this.pre_agreement = pre_agreement.data;
          this.pre_agreement_loaded = true;

          axios.get(this.crmApiPath + 'company/payment_process_info/company/' + this.$store.state.companies.current_record_company_id).then(payment_process_info => {
            this.payment_process_info = payment_process_info.data;
            this.payment_process_info_loaded = true;
          });
        });
      }
    }
  }
}
</script>
